.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  width: 100%;
}

.transport {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

/* The transport, and the shortcut help at its end */
.bar {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.transportBar {
  flex: 1;
}

/*
 * Spec §9: on a phone the transport is a bar pinned to the bottom of the edit view, inside the layout.
 * Sticky-bottom pins only what sits below the fold, so the bar moves to the end of the editor there.
 */
@media (max-width: 599.95px) {
  .bar {
    order: 10;
    position: sticky;
    bottom: 0;
    /* Above the keyboard's black keys, which stack at 1 and come later (Joni, M1–M5 review) */
    z-index: 2;
    /* Clear of the app's + button, 56px at the bottom right above the tab bar (root-main .fab) */
    padding: var(--tuna-spacing-1) calc(56px + var(--tuna-spacing-2) * 2) var(--tuna-spacing-1) 0;
    background: var(--tuna-surface-elevated);
    border-top: 1px solid var(--tuna-border-subtle);
  }

  /*
   * The keyboard comes after the bar, so the bar sits above it rather than over it once it is in view, and room
   * below it lets the keys clear the app's + button at the end of the editor (Joni, M1–M5 review)
   */
  .keyboard {
    order: 11;
    padding-bottom: calc(56px + var(--tuna-spacing-2) * 2);
  }
}

.root:focus {
  outline: none;
}

.root:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.cursor {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  font-variant-numeric: tabular-nums;
}

.issues {
  margin: 0;
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-palette-warning-light);
  color: var(--tuna-content-primary);
  font-size: var(--tuna-typography-body2-fontSize);
  list-style: none;
}

.keyboard {
  width: 100%;
}

/* The lane, the roll and the velocity lane, where the roll's shortcuts work (spec §10) */
.plotArea {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

/* The lane and the roll: the lane sticks within it, so it leaves when the roll scrolls away (Joni, M1–M5 review) */
.stickArea {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

/*
 * Sticks to the page above the roll (spec §9); it scrolls sideways only with the roll, never by itself. In a song
 * it sticks below the song's own sticky sections nav, which publishes where it ends (Joni, M1–M5 review).
 */
.laneTrack {
  position: sticky;
  top: var(--song-sticky-bottom, 0px);
  z-index: 1;
  width: 100%;
  overflow: hidden;
  background: var(--tuna-surface-elevated);
}

/* Spec §5.3: one line under the roll about the selected note */
.whyLine {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-primary);
}

.scroller {
  width: 100%;
  overflow-x: auto;
}

.plot {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

/* Spec §9: on a phone each bar keeps room for a 44px chord button and its 44px edge handle */
@media (max-width: 599.95px) {
  .plotWidth {
    min-width: calc(var(--roll-bars) * 5.75rem);
  }
}
